import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../../notes/icon/icon.module';
import { ModelAttributeModule } from '../../notes/model-attribute/model-attribute.module';
import { ShowUnlessDirective } from '../../shared/directives/show-unless.directive';

import { ModelAttributeGridListComponent } from './model-attribute-grid-list.component';

@NgModule({
  declarations: [ModelAttributeGridListComponent, ShowUnlessDirective],
  imports: [CommonModule, IconModule, ModelAttributeModule],
  exports: [ModelAttributeGridListComponent],
})
export class ModelAttributeGridListModule {}
